import React from "react";
import "../CSS/About.css";

const About = () => {
  const services = [
    {
      number: "01",
      title: "CANDIDATE PORTAL",
      subtitle: "Your journey towards opportunity starts here.",
      description:
        "Create your profile, apply for placements and jobs, access training, and track your progress.",
    },
    {
      number: "02",
      title: "OPPORTUNITIES",
      subtitle: "Discover opportunities. Take your next step.",
      description:
        "Find attachments, internships, jobs, training programmes, events and more.",
    },
    {
      number: "03",
      title: "AGENT ACCESS",
      subtitle: "Connect talent with opportunity.",
      description:
        "Register candidates, manage referrals and support successful placements.",
    },
    {
      number: "04",
      title: "PARTNER ORGANISATIONS",
      subtitle: "Connect your organisation with the right talent.",
      description:
        "Request students, interns, employees and skilled talent through ACL.",
    },
    {
      number: "05",
      title: "SKILLS TRAINING",
      subtitle: "Learn today. Advance tomorrow.",
      description:
        "Build practical skills in AI, digital technology, communication, professionalism, entrepreneurship and workplace readiness.",
    },
    {
      number: "06",
      title: "CAREER GUIDANCE",
      subtitle: "Make informed choices. Build with direction.",
      description:
        "Get guidance on career development, applications, interviews and professional growth.",
    },
    {
      number: "07",
      title: "CV & INTERVIEW SERVICES",
      subtitle: "Present your potential with confidence.",
      description:
        "Get support with CVs, professional profiles, applications and interview preparation.",
    },
    {
      number: "08",
      title: "EVENTS & PROGRAMMES",
      subtitle: "Learn. Connect. Experience. Grow.",
      description:
        "Discover career events, workshops, networking opportunities and development programmes.",
    },
    {
      number: "09",
      title: "SUPPORT CENTRE",
      subtitle: "We are here to help you move forward.",
      description:
        "Get assistance with ACL services, applications, placements, training and enquiries.",
    },
  ];

  return (
    <div className="acl-about">
      <section className="acl-hero">
        <div className="acl-hero-glow"></div>

        <div className="acl-hero-content">
          <div className="acl-eyebrow">ADVENWARE CAREER LINK</div>

          <h1>
            Where Potential
            <span>Becomes Possibility.</span>
          </h1>

          <div className="acl-hero-line"></div>

          <p>
            Advenware Career Link (ACL) is a dynamic talent and career
            advancement network engineered to bridge the distance between
            ambition and achievement.
          </p>

          <p>
            From attachment and internship placements to job opportunities,
            professional skills training, career guidance, CV development,
            interview preparation, and talent development, we create pathways
            that equip individuals with the experience, competence, and
            confidence to move forward.
          </p>

          <p>
            For organisations, we connect ambition with opportunity by
            facilitating access to emerging talent, skilled professionals,
            and dependable human capital.
          </p>

          <div className="acl-hero-statement">
            <span>The future belongs to those who</span>
            <strong>position themselves for it.</strong>
          </div>

          <div className="acl-hero-actions">
            <a href="#services" className="acl-primary-btn">
              Explore ACL
              <span>↗</span>
            </a>

            <a href="#journey" className="acl-secondary-btn">
              Start your journey
            </a>
          </div>
        </div>

        <div className="acl-scroll-indicator">
          <span></span>
          Scroll to explore
        </div>
      </section>

      <section className="acl-mission">
        <div className="acl-section-label">OUR PURPOSE</div>

        <div className="acl-mission-grid">
          <div>
            <h2>
              Turning ambition
              <br />
              into <span>momentum.</span>
            </h2>
          </div>

          <div className="acl-mission-copy">
            <p>
              We believe potential should never be limited by a lack of access
              to opportunity, experience, guidance, or the right connections.
            </p>

            <p>
              ACL brings these elements together in one connected ecosystem —
              helping individuals discover opportunities, develop relevant
              skills, gain experience and confidently take their next step.
            </p>
          </div>
        </div>
      </section>

      <section className="acl-services" id="services">
        <div className="acl-services-heading">
          <div>
            <div className="acl-section-label">WHAT WE OFFER</div>

            <h2>
              One platform.
              <br />
              <span>Multiple pathways.</span>
            </h2>
          </div>

          <p>
            Whether you're searching for your first opportunity, developing
            your professional edge, or looking for exceptional talent, ACL
            provides a pathway designed around your next move.
          </p>
        </div>

        <div className="acl-services-list">
          {services.map((service) => (
            <div className="acl-service" key={service.number}>
              <div className="acl-service-number">{service.number}</div>

              <div className="acl-service-main">
                <h3>{service.title}</h3>
                <h4>{service.subtitle}</h4>
                <p>{service.description}</p>
              </div>

              <div className="acl-service-arrow">↗</div>
            </div>
          ))}
        </div>
      </section>

      <section className="acl-philosophy">
        <div className="acl-philosophy-inner">
          <div className="acl-section-label">THE ACL APPROACH</div>

          <h2>
            Explore.
            <span> Elevate.</span>
            <br />
            Secure.
          </h2>

          <p>
            Explore an opportunity. Elevate your skills. Secure your next
            chapter.
          </p>
        </div>
      </section>

      <section className="acl-journey" id="journey">
        <div className="acl-journey-card">
          <div className="acl-section-label">START YOUR JOURNEY</div>

          <h2>
            Your potential
            <br />
            has a <span>destination.</span>
          </h2>

          <p>
            Explore an opportunity. Develop your skills. Build your experience.
            Shape your future.
          </p>

          <a href="/opportunities" className="acl-journey-btn">
            Begin your journey
            <span>→</span>
          </a>
        </div>
      </section>

      <footer className="acl-footer">
        <div className="acl-footer-brand">
          <strong>ADVENWARE</strong>
          <span>CAREER LINK</span>
        </div>

        <div className="acl-footer-tagline">
          Empowering Talent. Building Careers. Transforming Futures.
        </div>
      </footer>
    </div>
  );
};

export default About;